/**
 * @generated SignedSource<<c9a4e7916d1cd43b5ec8b93a1933ab1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionsWatchLazy_item$data = {
  readonly isAuctionWatchCtaVisible: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionsWatch_item">;
  readonly " $fragmentType": "PdpSharedAuctionsWatchLazy_item";
};
export type PdpSharedAuctionsWatchLazy_item$key = {
  readonly " $data"?: PdpSharedAuctionsWatchLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionsWatchLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionsWatchLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionsWatch_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionWatchCtaVisible",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "595005afe936a97b4866eba89ec61f2a";

export default node;
